module.exports = __webpack_public_path__ + "static/media/blinds-raised.9f347700.svg";